import { withIcon } from "../Icon"

export const IconTracking = withIcon(
  '<rect width="3" height="1" x="5" y="12" fill="currentColor" rx=".5"/><rect width="3" height="1" x="5" y="14" fill="currentColor" rx=".5"/><circle cx="16.5" cy="12.5" r="3.85" fill="none" stroke="currentColor" stroke-width="1.3"/><path fill="none" stroke="currentColor" stroke-width="1.3" d="M15.65 16.65h1.7v1.85a.85.85 0 0 1-1.7 0v-1.85ZM18 9V6.5a2 2 0 0 0-2-2H5.5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11H15"/>',
)
